import React from "react";
import { Link } from 'react-router';
import { maskRedirectLink } from '../../../../utils/utils';
import { format } from 'date-fns';

const MobileNotifMenu = ({isShown, notification, readAllNotification, readNotification, closeSideNav}) => {
  const handleClick = (id, data) => {
    const read = 1;
    closeSideNav()
    readNotification(id,read);

    if (data && data.redirection_type === "delivered") {
      window.open(
        `https://www.surveymonkey.com/r/5CWMVST?account_number=${data.account_number}&tracking_number=${data.tracking_number}&date_delivered=${data.delivered_date}&origin_country=${data.origin}&shipment_method=${data.shipment_method}`,
        "_blank"
      );
    }
  }

  const handleOverlayClick = () => {
    closeSideNav()
  }

  const handleReadAll = () => {
    const read = 1;
    const id = notification ? notification[0].attributes.party_id : null;
    readAllNotification(id,read);
  }
  return (
    isShown && 
    <div>
      <nav className="mobile-sidenav open-nav" style={{"marginRight": "0"}}>
        <div className="mobile-notification">
          <h3 className="notif-title">Notification{notification && notification.length >= 2 ? "s" : null} &nbsp;
          {notification && notification.length === 0 ? null : <span className="notif-count">{notification.length} new</span>}
          {notification && notification.length === 0 ? null : <span className="notif-mark" role="button" onClick={handleReadAll}><span className="markasread icon-markasread" /> </span> }
          </h3>
          <div className="mobile-notif-body">
            <ul>
              {notification && notification.length !== 0 ?
                notification.map(notif =>
                  <li className="notif-list" key={notif.id}>
                    <Link className="mobile-notif-link" to={maskRedirectLink(JSON.parse(notif.attributes.data), notif.attributes.reference_id)} onClick={() => {
                      handleClick(notif.id, JSON.parse(notif.attributes.data))
                    }}>
                      <div direction="left"> 
                        <div className="f-left"><span className={`mobile-notif-icon ${JSON.parse(notif.attributes.data).icon}`}/></div>
                        <div direction="right" className="mobile-notif-details">
                          {JSON.parse(notif.attributes.data).redirection_type === "prohibited" 
                          ? <span className="vertical-box-orient">{notif.attributes.template} <span className="notif-tracking">{notif.attributes.reference_id}</span></span> :
                          JSON.parse(notif.attributes.data).redirection_type === "order_details" 
                          ? <span className="vertical-box-orient"><span className="notif-tracking">{JSON.parse(notif.attributes.data).tracking_number} </span>{notif.attributes.template}</span> :
                          JSON.parse(notif.attributes.data).redirection_type === "payment_success" ?
                          <span className="vertical-box-orient">{notif.attributes.template} <span className="notif-tracking">{JSON.parse(notif.attributes.data).tracking_number}</span></span> :
                          <span className="vertical-box-orient">{notif.attributes.template} (Transaction #<span className="notif-tracking">{notif.attributes.reference_id}</span>)</span>
                          }
                          <div className="notif-date">{format(notif.attributes.created_at, "MM/DD/YYYY hh:mma")}</div>
                        </div>
                      </div> 
                    </Link>
                    <ul className="mobile-mark-read">
                      <li>
                        <i className="markasread icon-markasread"  aria-hidden="true" role="button" onClick={() => {handleClick(notif.id)}}></i>
                      </li>
                    </ul>
                  </li>
                ):<li className="center mobile-empty"><span className="mobile-icon-empty icon-notif-empty"/><br/><h4 className="empty-msg">You have no notification</h4></li>
              }
            </ul>
          </div>
          <div className="see-all"><Link to="/notification">See all notifications</Link></div>
        </div>
      </nav>
      <div
        className="overlay-menu"
        data-do="notification"
        data-on="click"
        onClick={() => {
          handleOverlayClick()
        }}
        style={{
          opacity: 1,
          zIndex: 999,
        }}>
        <i className="fa fa-chevron-right"></i>
      </div>
    </div>
  )
}

export default MobileNotifMenu;


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/MobileHeader/MobileNotifMenu.js
 **/